export default __webpack_public_path__ + "static/media/person.12ea4f36.png";